import type { ReactNode } from "react";
import { useEffect } from "react";
import { CacheProvider } from "@emotion/react";
import createCache, { Options } from "@emotion/cache";
import rtl from "stylis-plugin-rtl";
import { getLocaleDirection, LocaleDirection } from "utils/getLocaleDirection";
import { useAppSettings } from "./AppSettingsContext";

export const LocaleDirectionProvider = ({ children }: { children?: ReactNode }) => {
  const { locale } = useAppSettings();
  const localeDirection = getLocaleDirection(locale);
  const options: Record<LocaleDirection, Options> = {
    rtl: { key: "css-rtl", stylisPlugins: [rtl] },
    ltr: { key: "css", stylisPlugins: [] },
  };
  const cache = createCache(options[localeDirection]);

  useEffect(() => {
    document.documentElement.lang = locale;
    document.documentElement.dir = localeDirection;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  return <CacheProvider value={cache}>{children}</CacheProvider>;
};
